import { resolveLessonSlug } from 'experienceComponents/Lesson/helpers'

const normalizeRoute = route => {
  if (typeof route !== 'string') return ''

  return route
    .trim()
    .replace(/\/+$/g, '')
    .split('/')
    .pop()
}

const getConnectorId = entry => {
  const connector = entry?.courseNodeConnector

  return (
    connector?.courseNodeEntryPoint ||
    connector?.id ||
    connector?.sys?.id ||
    null
  )
}

export const getLessonSummary = ({
  contentfulLesson,
  lessonIndex,
  lessonListIndex,
  lessonSummaries,
}) => {
  if (!Array.isArray(lessonSummaries)) return null

  const lessonConnectorId = getConnectorId(contentfulLesson)
  const lessonRoute = normalizeRoute(
    resolveLessonSlug({ contentfulLesson, lessonIndex }),
  )

  const matchingSummary = lessonSummaries.find(summary => {
    const summaryConnectorId = getConnectorId(summary)
    const summaryRoute = normalizeRoute(summary?.route)

    return (
      (!!lessonConnectorId && lessonConnectorId === summaryConnectorId) ||
      (!!lessonRoute && lessonRoute === summaryRoute)
    )
  })

  return matchingSummary || lessonSummaries[lessonListIndex] || null
}

const firstLessonCompleted = lessonChoices => {
  let lesson = null
  let lessonIndex = null
  lessonChoices.map((choice, index) => {
    if (!lesson && choice.doneAt) {
      lesson = choice
      lessonIndex = index
    } else if (
      choice.doneAt &&
      new Date(choice.doneAt) < new Date(lesson.doneAt)
    ) {
      lesson = choice
      lessonIndex = index
    }
  })
  return lessonIndex
}

const lessonWithMostRecentProgress = lessonChoices => {
  let lesson = null
  let lessonIndex = null
  lessonChoices.map((choice, index) => {
    if (!lesson && choice.updatedAt) {
      lesson = choice
      lessonIndex = index
    } else if (
      choice.updatedAt &&
      new Date(choice.updatedAt) > new Date(lesson.updatedAt)
    ) {
      lesson = choice
      lessonIndex = index
    }
  })
  return lessonIndex
}

export const getDefaultLessonABIndex = lessonChoices => {
  const hasProgress = lessonChoices.some(choice => choice.progress)
  const hasCompletion = lessonChoices.some(choice => choice.doneAt)

  if (hasProgress) {
    if (hasCompletion) {
      return firstLessonCompleted(lessonChoices)
    }
    return lessonWithMostRecentProgress(lessonChoices)
  }
}
